import { render, staticRenderFns } from "./Provisioning.vue?vue&type=template&id=b3941124&scoped=true"
import script from "./Provisioning.vue?vue&type=script&lang=js"
export * from "./Provisioning.vue?vue&type=script&lang=js"
import style0 from "./Provisioning.vue?vue&type=style&index=0&id=b3941124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3941124",
  null
  
)

export default component.exports